import { apiBaseUrlSelector, userDataSelector } from '@selectors/global';
import { setSubscriptionExpired } from '@actions/global';

export function makeApiActionCreator(
  _apiCall,
  startActionType,
  successActionType,
  errorActionType,
  paramsPreProcess,
) {
  return function(originalParams) {
    return async (dispatch, getState) => {
      const state = getState();
      const apiBaseUrl = apiBaseUrlSelector(state);
      let params = originalParams;
      if (paramsPreProcess) {
        params = paramsPreProcess({ params, state, apiBaseUrl });
      }
      const authenticationToken =
        'Token ' + userDataSelector(state).claims.api_token;
      dispatch({ ...params, type: startActionType });
      try {
        const data = await _apiCall(apiBaseUrl, authenticationToken, params);
        dispatch({ ...params, data, type: successActionType });
        return data;
      } catch (error) {
        if (error.statusCode === 402) {
          setSubscriptionExpired(true)(dispatch);
        }
        dispatch({ ...params, error, type: errorActionType });
        throw error;
      }
    };
  };
}

export const START = 'START';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export function createRequestTypes(base) {
  return [START, SUCCESS, ERROR].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}
